if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
          variantTitle: "[data-sticky-variant-title]",
          variantPrice: "[data-sticky-variant-price]",
          variantImage: "[data-sticky-variant-image]",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm?.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm?.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct?.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainProduct || !this.mainProductForm || !this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", "100%");
          return;
        }

        this.variantData = this.getVariantData();
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.domNodes.select?.value));
        this.updateVariantPresentation(this.currentVariant);

        const headerHeight = Number(MinimogSettings.headerHeight) || 66;
        this.headerHeight = headerHeight;
        const rootMargin = `-${headerHeight}px 0px 0px 0px`;

        this.container.style.setProperty("--m-translate-y", "100%");
        document.documentElement.classList.remove("stick-atc-show");

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            () => this.updateStickyState(),
            { threshold: 0, rootMargin }
          );
        }

        this.handlePositionChange = () => {
          if (this.positionFrame) return;
          this.positionFrame = requestAnimationFrame(() => {
            this.positionFrame = null;
            this.updateStickyState();
          });
        };
        window.addEventListener("scroll", this.handlePositionChange, { passive: true });
        window.addEventListener("resize", this.handlePositionChange);

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();

        this.setObserveTarget();
        this.updateStickyState();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        this.m95Breakpoint = mql;
        this.m95BreakpointChange = () => { this.setStickyAddToCartHeight(); this.handlePositionChange(); };
        mql.addEventListener("change", this.m95BreakpointChange);
        this.setStickyAddToCartHeight();
        this.waitForM93WhatsApp();

        this.domNodes.select.addEventListener("change", (e) => {
          const { target } = e;
          const variantPicker = this.mainProduct.querySelector('variant-picker');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
          this.updateVariantPresentation(this.currentVariant);
          this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

          const selectedOption = target.options[target.selectedIndex];
          const selectedOptionIds = selectedOption.dataset.options.split(',').filter(id => id);

          if (variantPicker) {
            selectedOptionIds.forEach((optionId) => {
              const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
              const { tagName } = input;
              switch (tagName) {
                case "OPTION":
                  const inputParent = input.parentNode; // select tag
                  inputParent.value = input.value;
                  break;
                case "INPUT":
                  input.checked = true;
                  break;
              }
            });
            variantPicker.dispatchEvent(new Event("change"));
          }
        });
      }

      disconnectedCallback() {
        this.m93ReadyObserver?.disconnect();
        this.m93LayoutObserver?.disconnect();
        clearTimeout(this.m93ReadyTimeout);
        window.removeEventListener("load", this.handlePositionChange);
        document.querySelector("#chat-bubble")?.style.removeProperty("translate");
        document.querySelector("#scroll-to-top-button")?.removeAttribute("data-m95-purchase-overlap");
        document.documentElement.style.removeProperty("--iyrs-m95-whatsapp-bottom");
        this.m95Breakpoint?.removeEventListener("change", this.m95BreakpointChange);
        this.observer?.disconnect();
        window.removeEventListener("scroll", this.handlePositionChange);
        window.removeEventListener("resize", this.handlePositionChange);
        if (this.positionFrame) cancelAnimationFrame(this.positionFrame);
      }

      updateStickyState() {
        if (!this.mainAddToCart || !this.container) return;
        const hasPassedPrimaryButton = this.mainAddToCart.getBoundingClientRect().bottom <= this.headerHeight;
        this.container.style.setProperty("--m-translate-y", hasPassedPrimaryButton ? 0 : "100%");
        document.documentElement.classList[hasPassedPrimaryButton ? "add" : "remove"]("stick-atc-show");
        this.m92Allowed ??= document.documentElement.classList.contains('iyrs-theme-t4')
          && !!this.mainProduct?.matches('product-info[id^="MainProduct-"][data-section-type="product-page"]:not([data-view-mode="quick-view"])')
          && !!this.mainProduct.querySelector('media-gallery[data-context="product"]');
        this.syncM95ScrollTop();
        this.positionM95WhatsApp(hasPassedPrimaryButton);
      }


      // The optional return-to-top action yields while its fixed rectangle
      // intersects actual buying controls. It restores automatically outside that area.
      // No quantity movement, global z-index change, or dependence on Dondy's arrival.
      syncM95ScrollTop() {
        // Yield to purchase controls on the native main PDP; QuickView is not the main product.
        if (!this.mainProduct?.matches('product-info[id^="MainProduct-"][data-section-type="product-page"]:not([data-view-mode="quick-view"])')) return;
        const button = document.querySelector('#scroll-to-top-button');
        if (!button) return;
        const r = button.getBoundingClientRect();
        const obstructs = [this.mainAddToCart,
          this.mainProduct.querySelector('.main-product__block-buy_buttons .m-quantity'),
          ...this.mainProduct.querySelectorAll('variant-picker .m-product-option')]
          .filter(Boolean).some(node => {
            const css = getComputedStyle(node), b = node.getBoundingClientRect();
            return css.visibility !== 'hidden' && css.display !== 'none' && b.width && b.height &&
              r.left < b.right && r.right > b.left && r.top < b.bottom && r.bottom > b.top;
          });
        button.toggleAttribute('data-m95-purchase-overlap', obstructs);
      }

      // M9.5: one viewport-space position calculation, never a read/modify loop
      // over an animated bottom or a previous translate. Only the native main PDP context.
      positionM95WhatsApp(stickyVisible) {
        if (!this.m92Allowed) return;
        const bubble = document.querySelector('#chat-bubble.whatsapp-widget');
        if (!bubble) return;
        // A transform on this bubble changes the containing block of Dondy's fixed chat.
        bubble.style.removeProperty('translate');
        const rect = bubble.getBoundingClientRect();
        const normalBottom = Number.parseFloat(bubble.style.bottom) || 10;
        const chatOpen = !!bubble.querySelector('.chat-fade-wrapper.open');
        if (chatOpen || !rect.width || !rect.height) {
          document.documentElement.style.setProperty('--iyrs-m95-whatsapp-bottom', normalBottom + 'px');
          return;
        }
        const barHeight = this.container.offsetHeight;
        let top = innerHeight - Math.max(normalBottom, stickyVisible ? barHeight + 16 : normalBottom) - rect.height;
        const blockers = stickyVisible ? [] : [this.mainAddToCart,
          this.mainProduct.querySelector('.main-product__block-buy_buttons .m-quantity'),
          ...this.mainProduct.querySelectorAll('variant-picker label, variant-picker select, variant-picker button')];
        blockers.push(document.querySelector('#scroll-to-top-button'));
        const bounds = blockers.filter(Boolean).filter(node => {
          const css = getComputedStyle(node);
          return css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) > 0.05;
        }).map(node => node.getBoundingClientRect())
          .filter(r => r.width && r.height && r.bottom > 0 && r.top < innerHeight && r.right > rect.left && r.left < rect.right)
          .sort((a,b) => b.top - a.top);
        for (const block of bounds) {
          if (top < block.bottom + 12 && top + rect.height > block.top - 12) top = block.top - rect.height - 12;
        }
        const bottom = Math.max(normalBottom, Math.ceil(innerHeight - Math.max(8, top) - rect.height));
        const value = bottom + 'px';
        if (document.documentElement.style.getPropertyValue('--iyrs-m95-whatsapp-bottom') !== value)
          document.documentElement.style.setProperty('--iyrs-m95-whatsapp-bottom', value);
      }

      waitForM93WhatsApp() {
        if (!this.m92Allowed) return;
        // Content-only ResizeObserver: changing a fixed bubble's bottom does not resize these nodes.
        if ('ResizeObserver' in window) {
          this.m93LayoutObserver = new ResizeObserver(this.handlePositionChange);
          for (const node of [this.mainProductInfo, this.container, this.mainProduct, this.mainProduct.querySelector('media-gallery')])
            if (node) this.m93LayoutObserver.observe(node);
        }
        const ready = () => {
          const bubble = document.querySelector('#chat-bubble.whatsapp-widget');
          if (!bubble) return false;
          this.m93ReadyObserver?.disconnect();
          clearTimeout(this.m93ReadyTimeout);
          this.m93LayoutObserver?.observe(bubble);
          if (this.isConnected) this.handlePositionChange();
          return true;
        };
        if (!ready() && 'MutationObserver' in window) {
          this.m93ReadyObserver = new MutationObserver(ready);
          this.m93ReadyObserver.observe(document.querySelector('#whatsapp-widget-root') || document.body, {childList:true,subtree:true});
          this.m93ReadyTimeout = setTimeout(() => this.m93ReadyObserver?.disconnect(), 20000);
        }
        window.addEventListener('load', this.handlePositionChange, {once:true});
        document.fonts?.ready.then(() => { if (this.isConnected) this.handlePositionChange(); });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainAddToCart);
          this.observeTarget = this.mainAddToCart;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      updateVariantPresentation(variant) {
        if (!variant || !this.domNodes.select) return;
        const option = Array.from(this.domNodes.select.options).find(({ value }) => Number(value) === Number(variant.id));
        if (!option) return;
        if (this.domNodes.variantTitle) this.domNodes.variantTitle.textContent = option.dataset.variantTitle || variant.title || "";
        if (this.domNodes.variantPrice) this.domNodes.variantPrice.textContent = option.dataset.variantPrice || "";
        if (this.domNodes.variantImage && option.dataset.variantImage) {
          this.domNodes.variantImage.src = option.dataset.variantImage;
          this.domNodes.variantImage.removeAttribute("srcset");
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');

        pickerFields.value = '';
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        const stickyBarHeight = this.container?.offsetHeight || this.offsetHeight;
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", stickyBarHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = stickyBarHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            this.domNodes.select.value = String(e.data.variant.id);
            this.updateVariantPresentation(this.currentVariant);
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
          } else {
            variantInput.value = '';
            this.toggleAddButton(true, window.MinimogStrings.unavailable)
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        let customFieldFirst = customFields[0];
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        }
      }
    }
  );
}
